import React from 'react';
import '../App.css'

const Order = ({ selectedProjectData }) => {
  // console.log("selectedProjectData:",selectedProjectData)
  if (!selectedProjectData) return <div>Loading...</div>;
  
  return (
    // <div className="wrapper">
    <>
      <h2>Case Name: {selectedProjectData.order.case_name}</h2>
      {selectedProjectData.tasks.map((task) => (
        <div key={task.task_id} style={{ marginBottom: '40px' }}>
          <h3>Project Name: {task.project_name}</h3>
          <table border="1" cellPadding="8" style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th>任務名稱</th>
                <th>負責人</th>
                <th>開始日</th>
                <th>到期日</th>
                <th>狀態</th>
                <th>備註</th>
              </tr>
            </thead>
            <tbody>
              {task.variants.map(variant =>
                variant.details.map(detail => (
                  <tr key={detail.detail_id}>
                    <td>{variant.task_name}</td>
                    <td>{detail.people}</td>
                    <td>
                      {detail.start_date
                        ? new Date(detail.start_date).toISOString().split("T")[0]
                        : ""}
                    </td>
                    <td>
                      {detail.due_date
                        ? new Date(detail.due_date).toISOString().split("T")[0]
                        : ""}
                    </td>
                    <td>{detail.status}</td>
                    <td>{detail.note}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      ))}
    </>
    // </div>
  );
};

export default Order;
